import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActionCard = ({ userType }) => {
  const navigate = useNavigate();

  const volunteerActions = [
    {
      icon: 'Search',
      title: 'Find Opportunities',
      description: 'Discover perfect-fit volunteer positions',
      action: () => navigate('/smart-opportunity-finder'),
      variant: 'default'
    },
    {
      icon: 'Calendar',
      title: 'Browse Events',
      description: 'Join upcoming community events',
      action: () => navigate('/event-experience-hub'),
      variant: 'outline'
    },
    {
      icon: 'GraduationCap',
      title: 'Learn Skills',
      description: 'Enhance your capabilities',
      action: () => navigate('/skills-development-academy'),
      variant: 'outline'
    },
    {
      icon: 'TrendingUp',
      title: 'View Journey',
      description: 'Track your impact progress',
      action: () => navigate('/volunteer-journey-tracker'),
      variant: 'outline'
    }
  ];

  const organizationActions = [
    {
      icon: 'Plus',
      title: 'Post Opportunity',
      description: 'Create new volunteer position',
      action: () => navigate('/smart-opportunity-finder'),
      variant: 'default'
    },
    {
      icon: 'Calendar',
      title: 'Create Event',
      description: 'Plan community gathering',
      action: () => navigate('/event-experience-hub'),
      variant: 'outline'
    },
    {
      icon: 'Users',
      title: 'Manage Volunteers',
      description: 'View and coordinate team',
      action: () => navigate('/organization-impact-profiles'),
      variant: 'outline'
    },
    {
      icon: 'BarChart3',
      title: 'View Analytics',
      description: 'Track organizational impact',
      action: () => navigate('/organization-impact-profiles'),
      variant: 'outline'
    }
  ];

  const actions = userType === 'volunteer' ? volunteerActions : organizationActions;

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border">
      <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Zap" size={24} className="text-accent" />
        Quick Actions
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action, index) => (
          <button
            key={index}
            onClick={action?.action}
            className="flex items-start gap-3 p-4 rounded-lg border border-border hover:border-primary hover:bg-muted transition-all text-left group"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
              <Icon name={action?.icon} size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">
                {action?.title}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-1">
                {action?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionCard;